/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_aggregate_metric_double.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Encode a numeric to an aggregate_metric_double.
 *
 * @example
 * ROW x = 3892095203
 * | EVAL agg_metric = TO_AGGREGATE_METRIC_DOUBLE(x)
 *
 * @example
 * ROW x = [5032, 11111, 40814]
 * | EVAL agg_metric = TO_AGGREGATE_METRIC_DOUBLE(x)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_aggregate_metric_double',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'aggregate_metric_double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'aggregate_metric_double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'aggregate_metric_double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'aggregate_metric_double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'aggregate_metric_double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'unsigned_long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'aggregate_metric_double',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
